/** AppKit / viem 链上 ID 常为 bigint，Math.floor(min…) 会抛 Cannot convert a BigInt value to a number */
let patched = false
const OrigNumber = typeof Number !== 'undefined' ? Number : null

function toNum(v) {
  if (!OrigNumber) return v
  if (typeof v === 'bigint') return OrigNumber(v.toString())
  if (v != null && typeof v === 'object' && typeof v.valueOf === 'function') {
    const raw = v.valueOf()
    if (typeof raw === 'bigint') return OrigNumber(raw.toString())
  }
  return v
}

/** 仅 patch Math；不替换全局 Number（会破坏 Number.isFinite 等，旧 WebView 还会栈溢出） */
export function ensureMathBigIntSafe() {
  if (patched || typeof Math === 'undefined') return
  patched = true
  for (const name of ['floor', 'ceil', 'round', 'trunc', 'min', 'max', 'sign', 'abs', 'pow', 'hypot']) {
    const orig = Math[name]
    if (typeof orig !== 'function') continue
    Math[name] = function (...args) {
      return orig.apply(this, args.map(toNum))
    }
  }
}

function deleteIdbDatabase(name) {
  return new Promise((resolve) => {
    try {
      const req = indexedDB.deleteDatabase(name)
      req.onsuccess = () => resolve()
      req.onerror = () => resolve()
      req.onblocked = () => resolve()
    } catch {
      resolve()
    }
  })
}

export async function clearWalletConnectStorage() {
  /* 清 localStorage */
  if (typeof localStorage !== 'undefined') {
    const keys = []
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (!k) continue
      const lower = k.toLowerCase()
      if (k.startsWith('wc@2') || lower.includes('walletconnect') || k === 'WCM_RECENT_WALLET_DATA') {
        keys.push(k)
      }
    }
    keys.forEach((k) => {
      try { localStorage.removeItem(k) } catch { void 0 }
    })
  }

  /* 清 IndexedDB — WC SDK v2 把 session/pairing 存在 WALLET_CONNECT_V2_INDEXED_DB，必须 await */
  if (typeof indexedDB !== 'undefined') {
    const knownNames = ['WALLET_CONNECT_V2_INDEXED_DB', 'wc@2:core:02:irn_session_stores', 'wc2']
    const toDelete = new Set(knownNames)

    if (typeof indexedDB.databases === 'function') {
      try {
        const list = await indexedDB.databases()
        for (const entry of list) {
          const n = String(entry.name || '').toLowerCase()
          if (n.includes('walletconnect') || n.includes('wc@2') || n.includes('wc2')) {
            toDelete.add(entry.name)
          }
        }
      } catch { void 0 }
    }

    await Promise.all([...toDelete].map(deleteIdbDatabase))
  }
}
